// =====================================================================
//  Calc.products — product-grid ordering + "best offer" marking.
//  Shared DOM plumbing only: no maths (each calculator ranks locally) and
//  no copy (sort intent arrives as data-* attributes, labels stay in HTML).
//
//  Which axes are worth offering as sort options:
//   - min amount / max tenure are eligibility gates, so every VISIBLE card
//     already satisfies them — sorting by them tells the user nothing.
//   - rate is monotonic in monthly wherever every bank is priced at the
//     user's own tenure, so it duplicates it. debt-consolidation is the
//     exception: it prices each bank over that bank's maxTenure.
//  Callers must key on the wrap ELEMENT, never the feed id: prod_id arrives
//  as a string while dataset reads coerce to a number.
// =====================================================================
(function () {
  window.Calc = window.Calc || {};

  const ORDER_LAST = 9999;   // hidden/ineligible cards can never lead the grid

  // Sets CSS `order` rather than moving nodes, so the server-rendered DOM
  // sequence survives for crawlers and the no-JS case.
  // `ranked` is best->worst; `bestWrap` is the best-VALUE card, independent of
  // the active sort — the badge marks the best offer even when sorted by name.
  function applyOrder(wraps, ranked, bestWrap) {
    const all = Array.prototype.slice.call(wraps || []);
    const position = new Map();
    (ranked || []).forEach((entry, i) => {
      if (entry && entry.wrap) position.set(entry.wrap, i);
    });

    all.forEach(wrap => {
      const i = position.has(wrap) ? position.get(wrap) : ORDER_LAST;
      wrap.style.order = String(i);

      const isBest = !!bestWrap && wrap === bestWrap;
      const cardEl = wrap.querySelector('.card');
      if (cardEl) {
        cardEl.classList.toggle('border-primary', isBest);
        cardEl.classList.toggle('border-2', isBest);
      }
      const badge = wrap.querySelector('.best-badge');
      if (badge) badge.classList.toggle('d-none', !isBest);
    });
  }

  // entries: [{ wrap, index, name, metrics }] -> new sorted array (not mutated).
  // `index` is the original DOM position, used as tie-breaker so the order
  // stays stable and doesn't jitter while the user types.
  function rank(entries, key, dir) {
    const sign = (dir === 'desc') ? -1 : 1;
    return (entries || []).slice().sort((a, b) => {
      let d;
      if (key === 'name') {
        d = String(a.name || '').localeCompare(String(b.name || ''));
      } else {
        const av = (a.metrics || {})[key];
        const bv = (b.metrics || {})[key];
        // A missing metric sinks to the bottom regardless of direction.
        if (av == null && bv == null) d = 0;
        else if (av == null) return 1;
        else if (bv == null) return -1;
        else d = av - bv;
      }
      return d !== 0 ? d * sign : (a.index - b.index);
    });
  }

  // Wires a sort <select>; each <option> carries data-sort-key/-dir, and the
  // template's `selected` option sets the default. Returns that initial sort.
  function bindSort(selectSel, onChange) {
    const el = document.querySelector(selectSel);
    if (!el) return null;

    const read = () => {
      const opt = el.selectedOptions ? el.selectedOptions[0] : el.options[el.selectedIndex];
      if (!opt) return null;
      return { key: opt.dataset.sortKey || 'best', dir: opt.dataset.sortDir || 'asc' };
    };

    el.addEventListener('change', () => {
      const sort = read();
      if (sort) onChange(sort);
    });

    return read();
  }

  Calc.products = { applyOrder, rank, bindSort, ORDER_LAST };
})();
